import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, useRoutes, Navigate } from "react-router-dom";
import "./index.css";
import Zh from "./Zh";
import App from "./App";
import AboutIm from "./AboutIm";
import AboutImZh from "./AboutImZh";
import NotificationInstructions from "./NotificationInstructions";
import ChineseAppleInstructions from "./ChineseAppleInstructions";
import Discovery from "./Discovery";
import NewHome from "./new_version/NewHome";
import Home from "./new_version/components/Home";

// ── Language auto-redirect ──────────────────────────────────────
// Run BEFORE React mounts to avoid React StrictMode double-render
// interfering with the sessionStorage flag.
if (window.location.pathname === "/") {
  const langs = navigator.languages?.length ? navigator.languages : [navigator.language];
  if (langs.some((l) => l.toLowerCase().startsWith("zh"))) {
    window.location.replace("/zh");
  }
}

// ── Routes ──────────────────────────────────────────────────────
const Routes = () => {
  const routes = useRoutes([
    { path: "/", element: <Home locale="en" /> },
    { path: "/zh", element: <Home locale="zh" /> },
    { path: "/about", element: <AboutIm /> },
    { path: "/about-zh", element: <AboutImZh /> },
    { path: "/notification-instructions", element: <NotificationInstructions /> },
    { path: "/chinese-apple-instructions", element: <ChineseAppleInstructions /> },
    {
      path: "/old",
      element: <App />,
    },
    { path: "/old/zh", element: <Zh /> },

    { path: "/discovery", element: <Discovery /> },
    { path: "/new-home", element: <NewHome /> },
    { path: "/message.group", element: <Navigate to="/" replace /> },
  ]);
  return routes;
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes />
    </BrowserRouter>
  </React.StrictMode>
);
